import { Model, Signal, View } from '@lernetz/ts-lib';
import { Subscription } from '@lernetz/ts-lib/src/Signal';

import template from './PopupPage.html';

export type PopupPageNavigation = 'close' | 'next' | 'previous';

export class PopupPage extends Model {

    public readonly navigate: Signal<PopupPageNavigation>;

    public hasPrevious: boolean;
    public hasNext: boolean;
    
    public constructor(dto) {
        super(dto);

        this.navigate = new Signal<PopupPageNavigation>();
    }
}

export class PopupPageView extends View<PopupPage> {

    private navigateSubscription: Subscription;

    public constructor() {
        super({ template });
    }

    init() {
        if (!this.data) return;

        this.navigateSubscription = this.data.navigate.subscribe(this.onNavigate.bind(this));
    }

    deinit() {
        this.navigateSubscription.unsubscribe();
    }

    private onNavigate() {
        this.node.scrollTop = 0;
    }
}
